import React, { FC } from "react";
import { Alert, Box, Divider } from "@mui/material";
import { PropertiesCard } from "shared-ts-ui-properties-card";
import { Flue, FlueUpdateSpec } from "firefly-my-chimney-ts-building";
import { useTranslation } from "react-i18next";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { FlueForm } from "./FlueForm";
import { Property } from "shared-ts-property";
import { If } from "shared-ts-ui-react";

export interface FluePanelProps {
  environment: CustomerEnvironmentId;
  flue: Flue;
  onChange: (update: FlueUpdateSpec) => void;
}

export const FluePanel: FC<FluePanelProps> = (props) => {
  const { flue, environment } = props;
  const { t: tFireflyDomain } = useTranslation("firefly-shared-ts-domain");
  const { t } = useTranslation("my-chimney-ts-translations");

  return (
    <Box>
      <PropertiesCard
        header={{
          title: `${t("Flue")}`,
          subtitle: t(
            "The fire department has recorded the following information about the flue"
          ),
        }}
        elevation={0}
      >
        <Property label={tFireflyDomain("Name")} value={flue.fields.name} />
        <Property
          label={tFireflyDomain("Type")}
          value={tFireflyDomain(`FlueType.${flue.fields.type}`)}
        />
        <Property label={tFireflyDomain("Height")} value={flue.fields.height} />
      </PropertiesCard>

      <If
        expression={flue.fields.shared === true}
        then={
          <Alert severity="info">
            {t("This flue is shared between dwelling units and therefore...")}
          </Alert>
        }
        else={
          flue.fields.name != null && (
            <>
              <Divider />
              <FlueForm
                flue={flue}
                environment={environment}
                onChange={props.onChange}
              />
            </>
          )
        }
      />
    </Box>
  );
};
